$(function() {
    var annee_courante = new Date().getFullYear();
    $(".annee_courante").text(annee_courante);
});